import React, { useState, useContext, useRef, useEffect } from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import { Image, ForestryLink } from '../../../../utilities'

import * as styles from './megaMenus.module.scss'
import { Context } from '../../../context'

const MegaMenu = ({ menu, activeMenu, setActiveMenu }) => {
  const [selected, setSelected] = useState<number | null>(null)
  const ref = useRef(null);

  const url = typeof window !== 'undefined' ? window.location.href
    .replace(window.location.origin, '') : ''

  const parseLink = link => {
    return link && link
      .replace('.forestry/content/pages', '')
      .replace('.json', '')
      .replace('home', '')
      .split('#')[0]
  }

  const links = menu.links.map(x => x.page)

  useEffect(() => {
    if (activeMenu === menu.title) {
      var matched = links.findIndex(x => parseLink(x) === url)
    
      if (matched >= 0) {
        setSelected(matched)
      } else {
        setSelected(0)
      }
    } else {
      setSelected(null)
    }

    const handleClick = e => {
      if (ref.current && !ref.current.contains(e.target) && activeMenu && !['My BTC','Blog'].includes(activeMenu) && window.innerWidth > 480) {
        setActiveMenu(undefined);
      }
    }

    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
    
  }, [activeMenu])

  const isActiveLink = (link, i) => selected === i || parseLink(link.page) === url

  const isActiveContent = (i) => selected === i

  return (
    <div className={styles.megaMenu + ` ${activeMenu === menu.title ? `${styles.show}` : ""}` + ` ${styles[`height${menu.links.filter(l => !l.hide).length}`]}`}>
      <div className={styles.left} ref={ref}>
        <h3>{menu.heading}</h3>
        <ul>
          {menu.links.filter(l => !l.hide).map((link, i) => (
            <li key={i} onMouseOver={() => setSelected(i)} className={isActiveLink(link, i) ? `${styles.selected}` : ""}>
              <ForestryLink className={styles.link} to={link.page}>
                <Image className={styles.linkIcon} src={link.icon} />
                <p>{link.label}</p>
              </ForestryLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default ({ activeMenu, setActiveMenu, index }) => {
  const context = useContext(Context);

  const { site: { siteMetadata: { header: { megaMenus } } } } = useStaticQuery(graphql`
  {
    site {
      siteMetadata {
        header {
          megaMenus {
            arrow
            arrowDark
            heading
            supportText
            title
            links {
              description
              icon
              image
              label
              page
              hide
            }
            icons {
              icon
              path
              text
            }
          }
        }
      }
    }
  }`)

  const handleLeave = () => {
    setActiveMenu(undefined);
  }

  const menu = megaMenus.find((menu, i) => menu.title === activeMenu && index === i);

  return (
    <div className={styles.megaMenus}>
      {!!menu && <div onMouseDown={handleLeave} className={styles.megaLink + `${activeMenu === 'Residential' ? ` ${styles.second}` : ""}` + `${activeMenu === menu.title ? ` ${styles.show}` : ` ${styles.hide}`}`}>
          <div className={styles.linkContainer}>
            <div key={menu.title} className={styles.link}>{menu.title}
              <span className={styles.arrowDark}>
                <Image className={styles.icon} src={menu.arrowDark} container />
              </span>
            </div>
          </div>
          <div className={styles.shadow + ` ${activeMenu === 'Residential' ? `${styles.widerShadow}` : ""}`}></div>
        </div>}
      {!!menu && <MegaMenu {...{ menu, activeMenu, setActiveMenu }} />}
      {!!menu && <div className={styles.shadowFirst + ` ${activeMenu === 'Business' ? `${styles.show}` : ""}` + ` ${styles[`height${menu.links.filter(l => !l.hide).length}`]}`}></div>}
      {!!menu && <div className={styles.shadowSecond + ` ${activeMenu === 'Residential' ? `${styles.show}` : ""}` + ` ${styles[`height${menu.links.filter(l => !l.hide).length}`]}`}></div>}
    </div>
  )
}
